import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { GuardHelperService } from 'src/app/modules/auth/guard-helper.service';

@Injectable()
export class PEAPsGuard {
  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly guardHelperService: GuardHelperService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.guardHelperService.canActivate(route, state, this.checkPermissions.bind(this));
  }

  checkPermissions(url: string): boolean {
    let result = false;
    const account = this.authService.getCurrentAccount();

    if (!account.isActive) {
      void this.router.navigateByUrl(`${account.accountUID}/unauthorized`);
    }

    if (account.usePeaps) {
      result = true;
    }

    if (!result) {
      void this.router.navigateByUrl(`${account.accountUID}/mytrack/planning`);
    }

    return result;
  }
}
